/**
 * promptMasterService — mejora la REDACCIÓN de un prompt sin inventar nada.
 *
 * Es distinto de Directors: acá no se expande la idea ni se agregan detalles,
 * sólo se corrige y ordena lo que el usuario ya escribió. Cobra 1 crédito
 * cada 20 usos (el backend informa cuántos faltan).
 *
 * Usa axios para heredar el interceptor de auth global (igual que el resto de
 * los services).
 */
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const promptMasterService = {
  async enhance({ prompt, nodeType }) {
    const res = await axios.post(`${API_URL}/api/prompt-master/enhance`, {
      prompt,
      node_type: nodeType || 'generic',
    });
    return res.data;
  },

  async status() {
    const res = await axios.get(`${API_URL}/api/prompt-master/status`);
    return res.data;
  },
};

export default promptMasterService;
